import React, { useState, useEffect } from 'react';
import { Button, TextField, Dialog, Stack } from '@mui/material';
import { useMutation } from 'react-query';
import { createSpecialization, updateSpecialization } from 'src/services/specializations.service';
import { queryClient } from 'src';
import PulseLoader from 'src/components/loaders/PulseLoader';
import { useRecoilState } from 'recoil';
import { snackbarAtom } from 'src/atoms/snackbar';
const SpecializationDialog = ({ open, onClose, state, spec }) => {
  const [, setSnackbar] = useRecoilState(snackbarAtom);
  const [newSpec, setNewSpec] = useState('');
  const {
    mutate: createMutate,
    isLoading: createIsLoading,
    isError: createIsError,
    error: createError
  } = useMutation(createSpecialization, {
    onSuccess: () => {
      setNewSpec('');
      queryClient.invalidateQueries('specializations');
      onClose();
    }
  });

  const {
    mutate: updateMutate,
    isLoading: updateIsLoading,
    isError: updateIsError,
    error: updateError
  } = useMutation(updateSpecialization, {
    onSuccess: () => {
      setNewSpec('');
      queryClient.invalidateQueries('specializations');
      onClose();
    }
  });

  useEffect(() => {
    if (createIsError || updateIsError) {
      setSnackbar({
        open: true,
        message: 'An error has occurred: ' + (createError || updateError)?.message,
        severity: 'error'
      });
    }
  }, [createIsError, updateIsError]);

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <Stack
        style={{ padding: '1rem 2rem', minHeight: '30vh', minWidth: '30rem', gap: '2rem' }}
        alignItems={'center'}
        justifyContent={'space-evenly'}
      >
        <h2>{state === 'create' ? 'Add ' : 'Edit '}Specialization</h2>
        <TextField
          variant="outlined"
          label={'Specialization Name'}
          fullWidth
          onChange={(e) => setNewSpec(e.target.value)}
          defaultValue={state === 'edit' ? spec.specialization_description : ''}
        ></TextField>
        <Stack direction={'row'} gap={1} fullWidth justifyItems={'flex-end'}>
          <Button
            variant="contained"
            color={'incorta'}
            size="large"
            disabled={
              newSpec == '' ||
              createIsLoading ||
              updateIsLoading ||
              createIsError ||
              updateIsError ||
              (spec && newSpec == spec.specialization_description)
            }
            onClick={() => {
              if (state === 'create') createMutate(newSpec);
              else if (state === 'edit')
                updateMutate({ ...spec, specialization_description: newSpec });
            }}
            fullWidth
          >
            {createIsLoading || updateIsLoading ? <PulseLoader size={8} color="white" /> : 'Save'}
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => {
              setNewSpec('');
              onClose();
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default SpecializationDialog;
